export const appMessages = {
  "resetPasswordSucMsg": "Password reset successfully.Please log in again",
  "resetPasswordFailMsg": "Could not reset password",
  "uploadSucMsg": "uploaded successfully",
  "uploadFailMsg": "upload error",
  "createProjSucMsg": "Project Created",
  "createProjFailMsg": "Could not create project",
  "setProjSucMsg": "Project Updated",
  "setProjFailMsg": "Could not update project",
  "addMemberSucMsg": "Members added to project",
  "addManagersSucMsg": "Managers added to project",
  "addMemberFailMsg": "Could not add members to project",
  "addManagersFailMsg": "Could not add managers to project",
  "userProfileSucMsg":"Profile updated",
  "userProfileFailMsg":"Could not update profile"
}